// extracted by mini-css-extract-plugin
module.exports = {"Container":"RegionSelection_Container__Gcs_p","Content":"RegionSelection_Content__X_Rdx"};